var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9718 37.1178L12.752 33.459L33.9434 12.2676L36.3827 14.7066L13.9718 37.1178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5249 32.251L7.80469 31.1067L30.2941 8.61719L32.7264 11.0501L11.5249 32.251Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4274 11.6634L37.6017 13.4896L31.5117 7.3997L33.3369 5.57342C33.6739 5.23855 34.218 5.23855 34.555 5.57342L39.4267 10.4451C39.7619 10.7819 39.7622 11.3262 39.4274 11.6634Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5821 12.9053L13.0703 34.4171L13.9703 37.1171L36.3821 14.7053L34.5821 12.9053Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68407 35.708L5.32227 35.735V37.6682L5.54547 37.652L5.68407 35.708Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.089 33.9193L9.75183 33.5078L10.8091 36.68L9.8636 37.6257C9.70155 37.7863 9.48285 37.8768 9.25466 37.8777H7.45736L7.32812 39.6777H11.0541C11.2823 39.6768 11.501 39.5863 11.6631 39.4257L12.6086 38.48L11.089 33.9193Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4265 10.4445L37.6265 8.64453C37.9615 8.98152 37.9615 9.52578 37.6265 9.86277L35.8008 11.6891L37.6008 13.4891L39.4265 11.6628C39.7615 11.3258 39.7615 10.7815 39.4265 10.4445Z",
    fill: "currentColor",
    fillOpacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 39.5996H18.9C18.4029 39.5996 18 40.0026 18 40.4996C18 40.9967 18.4029 41.3996 18.9 41.3996H36.9C37.3971 41.3996 37.8 40.9967 37.8 40.4996C37.8 40.0026 37.3971 39.5996 36.9 39.5996Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6436 9.22743L35.7723 4.35573C34.7629 3.34757 33.1277 3.34757 32.1183 4.35573L4.35561 32.1177C3.87309 32.6036 3.60147 33.2601 3.59961 33.9448V39.6771C3.60129 40.6277 4.37132 41.3978 5.32185 41.3997H11.0548C11.7396 41.398 12.3961 41.1264 12.8818 40.6437L40.6436 12.8811C41.6509 11.8715 41.6509 10.237 40.6436 9.22743ZM13.9714 37.1177L12.7515 33.4588L33.9429 12.2674L36.3823 14.7064L13.9714 37.1177ZM7.80315 31.106L11.5234 32.2503L32.7249 11.0493L30.2925 8.61646L7.80315 31.106ZM11.0548 39.6771H7.32939L7.48509 37.5079L5.32275 37.6688V33.9448C5.32309 33.7165 5.41367 33.4975 5.57475 33.3357L6.42633 32.4841L11.0901 33.9194L12.6102 38.4801L11.6647 39.4258C11.5023 39.5864 11.2832 39.6766 11.0548 39.6771ZM37.6003 13.4891L39.4261 11.6628C39.7609 11.3256 39.7606 10.7813 39.4254 10.4445L34.5537 5.57284C34.2167 5.23796 33.6726 5.23796 33.3356 5.57284L31.5104 7.39912L37.6003 13.4891Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.c9318abdc7071b4a1e9c583ce46239b4.svg";